import { Component, Input } from '@angular/core';
import { Product } from '@queries/generated';

interface AddToCartItem {
  productId: number;
  quantity: number;
}
@Component({
  selector: 'vnm-product-catalog-item',
  templateUrl: './product-catalog-item.component.html',
  styleUrls: ['./product-catalog-item.component.scss']
})
export class ProductCatalogItemComponent {
  @Input() product!: Product;

  get discount(): number {
    return this.product.discount;
  }

  get price(): number {
    return this.product.price;
  }

  get priceWithDiscount(): number {
    return this.product.priceWithDiscount;
  }
}
